intra_module.factory('Log', function($resource, api_url, gsa_url) {
    const url    = `${gsa_url}/students/:login/logs`;
    const params =
        {login: '@login'};

    const actions = {
        getLogs: {
            method:          'GET',
            url:             `${gsa_url}/students/:login/logs`,
            isArray:         false,
            withCredentials: true
        },
        getSchedules: {
            method:          'GET',
            url:             `${gsa_url}/students/:login/schedules`,
            isArray:         false,
            withCredentials: true
        },
        getSchedulesCurrentRun: {
            method:          'GET',
            url:             `${gsa_url}/students/:login/schedules_current_run`,
            isArray:         false,
            withCredentials: true
        },
        computeLogsPerUvForOneStudent: {
            method:          'GET',
            url:             `${gsa_url}/students/:login/contracts/logs`,
            isArray:         false,
            withCredentials: true
        },
        declareLogs: {
            method:          'POST',
            url:             `${api_url}/modules/:module/declareLogs`,
            params: {
                module:   '@module'
            },
            isArray:         false,
            withCredentials: true
        },
        getDeclarations: {
            method:          'GET',
            url:             `${gsa_url}/students/:login/declarations`,
            isArray:         false,
            withCredentials: true
        }
    };

    return $resource(url, params, actions);
});
